module.exports = "https://coursera_assets.s3.amazonaws.com/images/cfc6b5b34bee303d29c45e6780cfe601.jpg";